import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import { UserIdentity } from './userIdentity';
import { socialLogin } from './socialSignOn';

/*
 * Intended to be used as the final step in the oauth token exchange with Apple.
 * Once the user logs into the Apple window, they will be redirected back to the redirect URL that you have configured in your authentication provider settings in Arc Subscriptions.
 * There will be a `code` query parameter appended to that URL that you should then pass to this method.
 *
 * @returns
 * A __Promise__ with user info data. When successful, the accessToken in `userIdentity` will be updated.
 *
 * <details>
 * <summary>
 * On success (resolves)
 * </summary>
 *
 * ```json
 * {
 *     "uuid": "c7e9fed4-bedf-428b-a694-1bbd21721cf7",
 *     "accessToken": "c7e9fed4bedf428b.a6941bbd21721cf7..."
 * }
 * ```
 * </details>
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/Authentication/login
 *
 * ```
 * </details>
 *
 */

export const appleSignOn = async (
  code: string
): Promise<UserIdentity | APIErrorResponse> => {
  return socialLogin('apple', { credentials: code });
};

export default appleSignOn;
